const regexNoSpecialCharacter = /[^a-z0-9]/gi;

export function NoSpecialCharacter(val) {
  return val?.replace(regexNoSpecialCharacter, '');
}
